import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reportfilter',
  templateUrl: './reportfilter.component.html',
  styleUrls: ['./reportfilter.component.css']
})
export class ReportfilterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/myreports/reportfilter/reportfilter.component.ts